import { CommonModule } from '@angular/common';
import { Component, inject, effect, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDatepickerModule, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetGenerateService } from '@services/budget-generate.service';
import Swal from 'sweetalert2';
import { registerLocaleData } from '@angular/common';
import { Entity } from '@model/entity.model';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { EmployeeModel } from './budget.model';
import { SettingBudgetComponent } from './setting-budget/setting-budget.component';
import { PermissionService } from '@services/core/permission.service';
import { HasRoleDirective } from '@directives/app-has-role.directive';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';


registerLocaleData(localeEs);


@Component({
  selector: 'app-budget',
  standalone: true,
  imports: [ CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbModule,
    SettingBudgetComponent,
    HasRoleDirective
  ],
  providers: [NgbModal,{ provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './budget.component.html',
  styleUrl: './budget.component.css',
})
export class BudgetComponent {
  @ViewChild('modal_budget', { static: true }) modalBudget: any;
  @ViewChild('modal_clone_budget', { static: false }) modalCloneBudget: any;
  @ViewChild('ngSelectAssinet', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild('ngSelect', { static: false }) ngSelect: NgSelectComponent;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  private _budgeGenrateService = inject(BudgetGenerateService);
  public filter: EmployeeModel = new EmployeeModel();
  public entitySelected: Entity;
  public dataEmployeeType;
  public dataListDiverse;
  public dataNgSelectAssinet;
  public budget;  
  public budgetTemp;
  public txtFind;
  public tabArea = 'diverse';
  public modalHeaderBudget: string;
  public formBudget: FormGroup;
  public formCloneBudget: FormGroup;
  public sourceBudgetSelected: any;
  public budgetFinded=false
  public budgetCopy;
  public isNewBudget=false
  public loadingId;
  closeResult: string;
  modalOptions = {
    animation: true,
  };
  public usePreviousBudget=false;
  public budgetVersionSelected;
  public isActiveSettingBudget=false;
  public isReadOnlyBudget = false;
  public budgetVersion;
  public appHasAccess: string[] = [];
  public aasinetFundSelect;
  public aasinetFund;
  public year;
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,
    private permissionService: PermissionService
  ) {
      

    effect(()=> {
      this.entitySelected = this.userService.sharingEntity();    
			this.budgetVersionSelected = this.userService.sharingBudgetVersion()
      this.getAasinetFund(); 
      this.getBudget(); 
       if (this.budgetVersionSelected?.year) {       
        this.filter.year = this.budgetVersionSelected.year;
        this.filter.version = this.budgetVersionSelected.version; 
        
      }
		})
  }


  /**crear formulario reactivo diverso*/
  createFormBudget() {
    this.formBudget = this.formBuilder.group({
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      year: [null, [Validators.required, Validators.min(this.year)]],
      version: ['', Validators.required],
      name: [null, [Validators.required]],
      vote: [''],
      status: [''],
      selected: [''],
      fundCode: [null,Validators.required],
    });
  }

  createFormCloneBudget() {
    this.formCloneBudget = this.formBuilder.group({
      sourceBudgetId: [null, [Validators.required]],
      sourceYear: [null, [Validators.required]],
      sourceVersion: [null, [Validators.required]],
      targetYear: [null, [Validators.required, Validators.min(2000)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit() {
    this.createFormBudget();
    this.createFormCloneBudget();
    this.appHasAccess = this.permissionService.appHasAccess;
    this.year = this.getDefaultBudgetYear();
  }

  /*obtiene el año sugerido segun si paso mitad de agosto*/
  getDefaultBudgetYear(): number {
    const today = new Date();
    const isPastMidAugust = today.getMonth() > 7 || (today.getMonth() === 7 && today.getDate() >= 15);
    return isPastMidAugust ? today.getFullYear() + 1 : today.getFullYear();
  }

  /*valida si el presupuesto coincide con el activo*/
  isBudgetSelected(budget): boolean {
    return (budget?.year ?? 0) === this.filter.year && (budget?.version ?? 0) === this.filter.version;
  }

  
  getAasinetFund() {
    this._budgeGenrateService.getAasinetFund().subscribe(res => {
      this.aasinetFund=res.filter(d=>d.acceptEntries);
      this.aasinetFundSelect=this.ngSelectDataAasinetFund(this.aasinetFund);
    }, (error => console.error(error)));
  }

   /*mapea los datos del ng-select */
   ngSelectDataAasinetFund(aasinetFund) {
    aasinetFund.filter(d=>d.code!='')
    let newData = aasinetFund.map((d) => {
      return {
        code: d.code,
        nameCode: d.code + ' - ' + d.name,
        name: d.name
      }
    });
    return newData
  }

  findBudgetFund(fundCode) {
    return this.aasinetFund.find(d=>d.code==fundCode)
  }

  private syncSubAccounts() {
    return this._budgeGenrateService.syncAssinetSubAccount().pipe(
      catchError(err => {
        console.error('Error en SubAccounts', err);
        return of(null);
      })
    );
  }
  
  private syncDepartaments() {
    return this._budgeGenrateService.syncAssinetDepartament().pipe(
      catchError(err => {
        console.error('Error en Departaments', err);
        return of(null);
      })
    );
  }
  
  private syncAccounts() {
    return this._budgeGenrateService.syncAssinetAccount().pipe(
      catchError(err => {
        console.error('Error en Accounts', err);
        return of(null);
      })
    );
  }
  
  private syncFunds() {
    return this._budgeGenrateService.syncAssinetFund().pipe(
      catchError(err => {
        console.error('Error en Funds', err);
        return of(null);
      })
    );
  }

  openModalCloneBudget(budgetToClone?: any) {
    const targetYear = this.getDefaultBudgetYear();
    let source = budgetToClone;
    if (!source && this.budget && this.budget.length > 0) {
      // Priorizar un presupuesto cerrado (status === 1) o el primero de la lista
      source = this.budget.find(b => b.status === 1) || this.budget[0];
    }

    if (source) {
      this.sourceBudgetSelected = source;
      this.formCloneBudget.patchValue({
        sourceBudgetId: source.id,
        sourceYear: source.year,
        sourceVersion: source.version,
        targetYear: targetYear,
        name: `Presupuesto ${targetYear} (copia ${source.year}-v${source.version})`
      });
    } else {
      this.formCloneBudget.reset();
      this.formCloneBudget.patchValue({
        targetYear: targetYear
      });
    }

    this.open(this.modalCloneBudget);
  }

  onSourceBudgetChange(budgetId: any) {
    const found = this.budget?.find(b => b.id == budgetId);
    if (found) {
      this.sourceBudgetSelected = found;
      const targetYear = this.formCloneBudget.get('targetYear').value || this.getDefaultBudgetYear();
      this.formCloneBudget.patchValue({
        sourceYear: found.year,
        sourceVersion: found.version,
        name: `Presupuesto ${targetYear} (copia ${found.year}-v${found.version})`
      });
    }
  }

  onTargetYearChange() {
    const targetYear = this.formCloneBudget.get('targetYear').value;
    if (this.sourceBudgetSelected && targetYear) {
      this.formCloneBudget.patchValue({
        name: `Presupuesto ${targetYear} (copia ${this.sourceBudgetSelected.year}-v${this.sourceBudgetSelected.version})`
      });
    }
  }

  submitCloneBudget() {
    if (this.formCloneBudget.invalid) {
      this.formCloneBudget.markAllAsTouched();
      return;
    }
    const formValue = this.formCloneBudget.value;
    this.close();
    this.loading(`Clonando presupuesto hacia el año ${formValue.targetYear}...`);

    this._budgeGenrateService.cloneBudget({
      sourceYear: formValue.sourceYear,
      sourceVersion: formValue.sourceVersion,
      targetYear: formValue.targetYear,
      name: formValue.name
    }).subscribe({
      next: () => {
        Swal.close();
        this.getBudget();
        Swal.fire({
          icon: 'success',
          title: '¡Presupuesto clonado con éxito!',
          text: `Se ha creado una nueva versión en el año ${formValue.targetYear} en estado editable.`,
          timer: 3500,
          showConfirmButton: false
        });
      },
      error: (err) => {
        Swal.close();
        console.error('Error al clonar presupuesto:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error al clonar presupuesto',
          text: err.error?.message || err.error?.error || 'No se pudo completar la clonación.'
        });
      }
    });
  }
  
  private syncEmployees() {
        if(this.entitySelected?.group=='FUNDACION' ){
      return of(null);
    }
    return this._budgeGenrateService.syncApsEmployee().pipe(
      catchError(err => {
        console.error('Error en Employees', err);
        return of(null);
      })
    );
  }
  
  private syncDependents() {
        if(this.entitySelected?.group=='FUNDACION'){
      return of(null);
    }
    return this._budgeGenrateService.syncApsDependents().pipe(
      catchError(err => {
        console.error('Error en Dependents', err);
        return of(null);
      })
    );
  }
  
  private syncBudget(year: number) {
    return this._budgeGenrateService.syncAssinetBudget({ year }).pipe(
      catchError(err => {
        console.error('Error en Budget', err);
        return of(null);
      })
    );
  }
  
  private syncEmployeeAccounts(year: number) {
    if(this.entitySelected?.group=='FUNDACION'){
      return of(null);
    }
    return this._budgeGenrateService.syncApsEmployeeAccount({ year }).pipe(
      catchError(err => {
        console.error('Error en EmployeeAccounts', err);
        return of(null);
      })
    );
  }


  syncWithAasinet() {
    const year = new Date().getFullYear();
    this.loading('Sincronizando con Aasinet y APS');
  
    forkJoin({
      subAccounts: this.syncSubAccounts(),
      departaments: this.syncDepartaments(),
      accounts: this.syncAccounts(),
      funds: this.syncFunds(),
      employees: this.syncEmployees(),
      dependents: this.syncDependents(),
      budget: this.syncBudget(year),
      employeeAccounts: this.syncEmployeeAccounts(year)
    }).subscribe({
      next: (result) => {
        this.getAasinetFund();
        Swal.fire({
          icon: 'success',
          title: '¡Sincronización completada!',
          showConfirmButton: false,
          timer: 3000
        });
      }
    });
  }

  syncAllEntitiesAasinet() {
    Swal.fire({
      title: '¿Sincronizar todas las entidades?',
      text: 'Se iniciará la sincronización de cuentas y subcuentas para todas las entidades en segundo plano.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, sincronizar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this._budgeGenrateService.syncAasinetAllAccounts().subscribe({
          next: () => {
            Swal.fire({
              icon: 'success',
              title: 'Sincronización iniciada',
              text: 'El proceso se está ejecutando en segundo plano en el servidor. Puede consultar el estado en cualquier momento.',
              timer: 3500,
              showConfirmButton: false
            });
          },
          error: (err) => {
            if (err.status === 409) {
              Swal.fire({
                icon: 'warning',
                title: 'En ejecución',
                text: 'Ya hay una sincronización ejecutándose actualmente en el servidor.'
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.error?.message || 'Error al iniciar la sincronización'
              });
            }
          }
        });
      }
    });
  }

  checkSyncAllStatus() {
    this._budgeGenrateService.getSyncAasinetAllStatus().subscribe({
      next: (status) => {
        const last = status.lastExecution;
        let html = `
          <div class="text-start fs-13px">
            <p class="mb-1"><strong>Programación (Cron):</strong> <code>${status.schedule}</code> (medianoche cada noche)</p>
            <p class="mb-1"><strong>Zona horaria:</strong> ${status.timezone}</p>
            <p class="mb-2"><strong>Estado actual:</strong> ${status.isRunning ? '<span class="badge bg-warning text-dark">En ejecución</span>' : '<span class="badge bg-success">Inactivo (esperando medianoche)</span>'}</p>
        `;

        if (last) {
          const dateStr = new Date(last.timestamp).toLocaleString();
          const summary = last.summary;
          html += `
            <hr class="my-2">
            <p class="mb-1"><strong>Última ejecución:</strong> ${dateStr} (${last.triggeredBy})</p>
            <p class="mb-1"><strong>Resultado:</strong> ${last.success ? '<span class="text-success fw-bold">Exitosa</span>' : '<span class="text-danger fw-bold">Con errores</span>'}</p>
          `;
          if (summary) {
            html += `
              <p class="mb-1"><strong>Entidades procesadas:</strong> ${summary.processed} / ${summary.totalEntities}</p>
              <p class="mb-1"><strong>Duración:</strong> ${summary.durationSeconds} segundos</p>
              <p class="mb-1"><strong>Cuentas:</strong> ${summary.accounts.success} OK, ${summary.accounts.skipped} Omitidas, ${summary.accounts.errors} Errores</p>
              <p class="mb-0"><strong>Subcuentas:</strong> ${summary.subAccounts.success} OK, ${summary.subAccounts.skipped} Omitidas, ${summary.subAccounts.errors} Errores</p>
            `;
          }
        } else {
          html += `<hr class="my-2"><p class="text-muted mb-0">No se ha registrado ninguna ejecución previa aún.</p>`;
        }

        html += `</div>`;

        Swal.fire({
          title: 'Estado Sincronización Automática',
          html: html,
          icon: 'info',
          confirmButtonText: 'Cerrar'
        });
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo consultar el estado del cron'
        });
      }
    });
  }

  syncWithAps() {
    let date=new Date();
    let year=date.getFullYear();
    this._budgeGenrateService.syncApsEmployeeAccount({year:year}).subscribe(res => {
      this.getBudget();
    }, (error => console.error(error)));
  }
  

 
  /*mensaje de cargando */
  loading(title) {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


  /*trae los datos diverse en el servicio de budget  */
  getBudget() {
    this.loading('Cargando presupuesto');
    this._budgeGenrateService.getBudget().subscribe((res) => {
      this.budget = res;
        this.budgetTemp=JSON.parse(JSON.stringify(this.budget));
        this.dataListDiverse=this.ngSelectData(res)
      Swal.close();
    }, (error => console.error(error)));
  }



/**busca los diverso  */
  findEmployee(code): boolean {
    let isActive=false;
    isActive=!this.budget?.some((diverse) => diverse.code === code)
    return isActive
   
	}


  /*mapea los datos del ng-select */
  ngSelectData(diverse) {
    let newData = diverse.map((d) => {
      return {
        diverse: d.code,
        nameDiverse: d.code + ' - ' + d.names,
        name: d.names
      }
    });
    return newData
  }

    /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
    mapSelectAassinet(diverse) {
      let newData = diverse.map((d) => {
        const name=d.names
        const isActive = this.findEmployee(d.code);
        return {
          diverse: d.code,
          nameDiverse: d.code + ' - ' + name,
          name: name,
          disabled:!isActive,
          isActive:isActive
        }
      });
      return newData
    }

    closeSettingBudget(event) {
      this.isActiveSettingBudget=event;
    }

   /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
   onCloseNgSelectFind() {
    if(this.txtFind.length>0){
      this.budget=this.budgetTemp.filter(d=>
        this.txtFind.includes(d.code)
      );
    }else{
      this.budget=this.budgetTemp;
    }
  }



  /*abre los modales */
  open(content) {
    this.modalRef = this.modalService.open(content);
  }

   /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }


  /**abre el modal del diverse */

  /*abre el modal para crear nuevo presupuesto*/
  openModalBudget() {
    this.modalHeaderBudget = 'Nuevo Presupuesto';
    this.year = this.getDefaultBudgetYear();
    this.formBudget.reset();
    this.formBudget.get('fundCode').enable();
    this.formBudget.patchValue({
      entityCode: this.entitySelected?.code,
      year: this.year, version: '', name: null,
      vote: '', fundCode: null, status: 2, selected: 1
    });
    this.findBudgetVersion();
    this.open(this.modalBudget);
  }

  blockTyping(event: KeyboardEvent) {
    const allowedKeys = [
      'ArrowUp', 'ArrowDown', 'Tab', 'Backspace', 'Delete'
    ];
    
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  

  /*fija el presupuesto seleccionado como activo*/
  selectBudget(params) {
    this.loadingId = params.id;
    this._budgeGenrateService.setSelectedBudget({ year: params.year, version: params.version }).subscribe({
      next: () => this.handleSelectSuccess(params),
      error: () => this.loadingId = null
    });
  }

  /*procesa la confirmación de selección exitosa*/
  private handleSelectSuccess(params) {
    this.userService.refreshBudgetVersion().subscribe({
      next: () => {
        this.loadingId = null;
        this.showSelectToast(params);
      },
      error: () => this.loadingId = null
    });
  }

  /*muestra toast de confirmacion*/
  private showSelectToast(params) {
    Swal.mixin({
      icon: 'success', toast: true, position: 'top-end',
      showConfirmButton: false, timer: 2000, timerProgressBar: true
    }).fire({ title: `Presupuesto ${params.year}-${params.version} fijado como activo` });
  }
  
  findBudgetVersion() {
    const selectedYear = this.formBudget.get('year').value;
    const versionsByYear = this.budget.filter(d => d.year == selectedYear);
    let nextVersion = 1;  
    if (versionsByYear.length > 0) {
      const maxVersion = Math.max(...versionsByYear.map(d => d.version));
      nextVersion = maxVersion + 1;
    }
    this.formBudget.get('version').patchValue(nextVersion);
  }
  
  


  /*carga los datos al pinchar en la tabla editar o ver*/
  setFormBudget(params) {
    this.isNewBudget = false;
    this.isReadOnlyBudget = (params?.status ?? 0) !== 2;
    this.filter.year = params.year;
    this.filter.version = params.version;
    this.isActiveSettingBudget = true;
  }

  changeUsePreviousBudget() {
    if(this.usePreviousBudget){
      
    }
  }



  /**carga los datos al pinchar en la tabla editar */

  editBudget(){
    this.budgetFinded=true
  }

  /**cambia la fecha en formato compatible para el mostrar campo de fecha */
  setDate(date?) {
    const expirationDate = date ? new Date(date) : new Date();
    let formatDate = {
      year: date ? expirationDate.getFullYear() : expirationDate.getFullYear() + 1,
      month: expirationDate.getMonth() + 1,
      day: date ? expirationDate.getDate() : expirationDate.getDate() + 1
    };
    return formatDate
  }

  /**cambia la fecha en formato compatible para guardar la fecha en la base de datos */
  setDateSave(date) {
    let year = date.year;
    let month = date.month < 10 ? `0${date.month}` : date.month;
    let day = date.day < 10 ? `0${date.day}` : date.day;
    let newDate = `${year}-${month}-${day}`
    return newDate;
  }

  /**Elimnar diverso */
  deleteBudget(params) {
    const loadingToast = Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Estás seguro de eliminar el presupuesto: ' + params.year+'-'+params.version+ ' ' + params.name+'? Se eliminaran todos los registros asociados',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this._budgeGenrateService.deleteBudget(params).subscribe(res => { 
           this.userService.refreshBudgetVersion().subscribe();   
          this.getBudget();
        }, (error => console.error(error)))
      }
    });
  }


  generateFunds() {
    const funds=[];
    this.formBudget.get('fundCode').value.forEach(element => {
      const dataFund={
        entityCode: this.formBudget.get('entityCode').value,
        year: this.formBudget.get('year').value,
        version: this.formBudget.get('version').value,
        fundCode: element,
      }
      funds.push(dataFund);
    });
    return funds;
  }

 importBudget(params) {
    this.close();
    this.loading('Generando presupuesto '+params.year); 
    this.selectBudget(params)
    this._budgeGenrateService.importPreviousBudget(params).subscribe(res => {
   this.filter.year=this.formBudget.get('year').value;
   this.filter.version=this.formBudget.get('version').value;
   this.isActiveSettingBudget=true;  
        this.isActiveSettingBudget=true;
        Swal.close();
        this.close();
      
    }, (error => console.error(error)));
  }



  /*envia la informacion para un nuevo diverso*/
  submitBudgetNew() {
    if (this.formBudget.valid) {
      const funds=this.generateFunds();
      this.formBudget.get('fundCode').disable();
      this._budgeGenrateService.saveBudget(this.formBudget.value).subscribe(res => {
        this._budgeGenrateService.bulkCreateBudgetFund(funds).subscribe(res => { 
           
          this.importBudget({
            year:this.formBudget.get('year').value,
            version:this.formBudget.get('version').value
          })

        });
            
      }, (error => console.error(error)))
    }
  }

  /*envia la informacion para un actualizar diverso*/
  submitBudgetUpdate() {
    if (this.formBudget.valid) {
      this._budgeGenrateService.updateDiverse(this.formBudget.value).subscribe(res => {   
        this.userService.refreshBudgetVersion();   
        this.close();
      }, (error => console.error(error)))

    }
  }

  
  setEmployee(id) {
    return this.budget.find(em => em.id == id);
  }


  findEmployeetype(id) {
    const type=this.dataEmployeeType?.find(em => em.id == id);
    return type?type.name:id;
  }

  
  /*Activa o desactiva un diverso*/
  UpdateDiverseActive(params,isActive) {
    let employee=this.setEmployee(params.id)
    employee.is_active=isActive
    this._budgeGenrateService.updateDiverse({id:params.id,is_active:isActive}).subscribe(res => {
      const Toast = Swal.mixin({
        icon: 'success',
        title: 'Datos Actualizados',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
    });          
    Toast.fire();  
    }, (error => console.error(error)))
  }

  maxDateValidator(control: any) {
    const selectedDate = new Date(control.value);
    const today = new Date();

    // Ajuste para comparar solo fechas (sin horas)
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      return { dateInvalid: true }; // Error si la fecha es posterior a hoy
    }
    return null; // Válido si es igual o anterior a hoy
  }


}



